import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TiGroup, TiThListOutline } from "react-icons/ti";
import { FaClipboardList } from "react-icons/fa";
import axios from "axios";
import config from "../../config";

function AdminDashCont() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token2"); 

  useEffect(() => {
    if (!localStorage.getItem("token2")) {
      navigate("/");
    }
    const fetchData = async () => {
      try {
        const response = await axios.get(`${config.API_BASE_URL}/auth/AdminDashboard`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(response.data.data.dashboard_data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="custom-loader-container">
        <div className="custom-loader"></div>
      </div>
    );
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12 breadcrumb">
                <div className="page-header-title">
                  <h4 className="m-b-10">BOARD DASHBOARD</h4>
                </div>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><a href="#" onClick={() => navigate("/Board-dashboard")}>Home</a></li>
                  <li className="breadcrumb-item">Board Dashboard</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ padding: '0px' }}>
          <div className="col-md-6 col-xl-3">
            <a className="card card-blue" href="#" onClick={() => navigate("/Board-pending-verification")} style={{height:"144px"}}>
              <div className="card-body">
                <h6 className="mb-2 f-w-400 text-muted">Total Payments Pending for Verification</h6>
                <h4 className="mb-3 mt-3">{data?.TOTAL_PAYMENT_PENDING_VERIFICATION || 0}</h4>
                <p className="mb-0 text-primary">Click Here to See Details >></p>
              </div>
              <TiGroup className="text-blue-300 text-6xl card-icon" />
            </a>
          </div>
          <div className="col-md-6 col-xl-3">
            <a className="card card-green" href="#" onClick={() => navigate("/Board-approved-payment")}>
              <div className="card-body">
                <h6 className="mb-2 f-w-400 text-muted">Total Approved Payments</h6>
                <h4 className="mb-3 mt-3">{data?.TOTAL_APPROVED_PAYMENTS || 0}</h4>
                <p className="mb-0 text-success">Click Here to See Details >></p>
              </div>
              <TiGroup className="text-green-300 text-6xl card-icon" />
            </a>
          </div>
          <div className="col-md-6 col-xl-3">
            <a className="card card-red" href="#" onClick={() => navigate("/Board-rejected-payment")}>
              <div className="card-body">
                <h6 className="mb-2 f-w-400 text-muted">Total Rejected Payments</h6>
                <h4 className="mb-3 mt-3">{data?.TOTAL_REJECT_PAYMENTS || 0}</h4>
                <p className="mb-0 text-danger">Click Here to See Details >></p>
              </div>
              <TiThListOutline className="text-red-300 text-6xl card-icon" />
            </a>
          </div>
          <div className="col-md-6 col-xl-3">
            <a className="card card-yellow" href="#" onClick={() => navigate("/Board-pending-payment")}>
              <div className="card-body">
                <h6 className="mb-2 f-w-400 text-muted">Challan Pending for Submission</h6>
                <h4 className="mb-3 mt-3">{data?.TOTAL_CHALLAN_PAYMENTS || 0}</h4>
                <p className="mb-0 text-warning">Click Here to See Details >></p>
              </div>
              <FaClipboardList className="text-yellow-300 text-6xl card-icon" />
            </a>
          </div>
          {/* <div className="col-md-6 col-xl-3">
            <a className="card card-maroon" href="#" onClick={() => navigate("/board-reports")}>
              <div className="card-body">
                <h6 className="mb-2 f-w-400 text-muted">Reports </h6>
                <h4 className="mb-3 mt-3">{data?.TOTAL_CHALLAN_PAYMENTS || 0}</h4>
                <p className="mb-0 text-maroon">Click Here to See Details >></p>
              </div>
              <FaClipboardList className="text-maroon-300 text-6xl card-icon" />
            </a>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default AdminDashCont;
